import { isAxiosError } from 'axios'

import { CommonError } from '@/dto/common/CommonError'

// 부팅 중 난 실패를 직접 보고할지 정한다. 서버 요청 실패는 전부 제외한다 — maxios 가 감싼
// CommonError 든, 변환 없는 인스턴스가 던진 날것 AxiosError 든 같다.
// - 4xx(토큰 만료·이용기간 만료·권한 없음)는 로그인으로 보내는 예상된 흐름이다
// - 응답 없는 실패(network)는 axios 인터셉터가 이미 보고하므로 여기서 또 보내면 중복이다
// - 5xx는 백엔드가 추적한다
// 남는 것은 부팅 코드 자체의 런타임 예외(TypeError 등)뿐이고, 이건 지금까지 console 에만 남았다.
export const shouldReportBootFailure = (error: unknown): boolean =>
  !(error instanceof CommonError) && !isAxiosError(error)
